(() => {
  function initOne(root) {
    if (!root || root.dataset.dkMapInit === "1") return;
    root.dataset.dkMapInit = "1";

    const titleEl = root.querySelector('[data-dk-title]');
    const resultsEl = root.querySelector('[data-dk-results]');
    const regions = Array.from(root.querySelectorAll('[data-landsdel]'));
    const jsonEl = root.querySelector('#dk-camps-data');
    const svgEl = root.querySelector('svg.dk-map');

    if (!jsonEl || !resultsEl || regions.length === 0) return;

    let camps = [];
    try {
      camps = JSON.parse(jsonEl.textContent || "[]");
    } catch (e) {
      console.warn("Kunne ikke parse camps JSON", e);
      return;
    }

    const labels = {
      jylland: "Camps i Jylland",
      fyn: "Camps på Fyn",
      sjaelland: "Camps på Sjælland"
    };

    const canHover =
      window.matchMedia &&
      window.matchMedia("(hover: hover) and (pointer: fine)").matches;

    // --- NYT: lock state ---
    let lockedLandsdel = null;

    function setPointerMode(lockKey) {
      // Når lockKey findes: kun den valgte region må modtage pointer events.
      // Det stopper både JS-hover OG CSS :hover på de andre.
      regions.forEach(r => {
        if (!lockKey) {
          r.style.pointerEvents = "";
        } else {
          r.style.pointerEvents = r.dataset.landsdel === lockKey ? "" : "none";
        }
      });
    }

    function resetUI() {
      lockedLandsdel = null;
      setPointerMode(null);

      regions.forEach(r => r.classList.remove("active"));

      if (titleEl) {
        titleEl.style.opacity = 0;
        setTimeout(() => {
          titleEl.textContent = "Camps";
          titleEl.style.opacity = 1;
        }, 150);
      }

      resultsEl.innerHTML =
        "<p class='dk-empty'>Vælg et område for at se camps.</p>";
    }

    function render(landsdel) {
      regions.forEach(r =>
        r.classList.toggle("active", r.dataset.landsdel === landsdel)
      );

      const matches = camps.filter(c => c.landsdel === landsdel);

      if (titleEl) {
        titleEl.style.opacity = 0;
        setTimeout(() => {
          titleEl.textContent = labels[landsdel] || "Camps";
          titleEl.style.opacity = 1;
        }, 150);
      }

      if (matches.length === 0) {
        resultsEl.innerHTML =
          "<p class='dk-empty'>Ingen camps fundet i dette område.</p>";
      } else {
        resultsEl.innerHTML = matches
          .map(
            c => `
          <div class="camp-card">
            <div><strong>${c.title}</strong></div>
            <a class="camp-btn" href="${c.url}">Se camp →</a>
          </div>
        `
          )
          .join("");

        // Stagger animation
        const cards = resultsEl.querySelectorAll(".camp-card");
        cards.forEach((card, i) => {
          setTimeout(() => card.classList.add("show"), 80 * i);
        });
      }

      // Auto scroll mobil
      const isTouch =
        window.matchMedia &&
        window.matchMedia("(hover: none) and (pointer: coarse)").matches;

      if (isTouch) {
        const y =
          resultsEl.getBoundingClientRect().top +
          window.scrollY -
          80;
        window.scrollTo({ top: y, behavior: "smooth" });
      }
    }

    regions.forEach(region => {
      const landsdel = region.dataset.landsdel;

      if (canHover) {
        region.addEventListener("mouseenter", () => {
          // NYT: hvis noget er låst, så ignorer hover
          if (lockedLandsdel) return;
          render(landsdel);
        });
      }

      region.addEventListener("click", e => {
        e.preventDefault();
        e.stopPropagation();

        // NYT: klik på samme => unlock
        if (lockedLandsdel === landsdel) {
          resetUI();
          return;
        }

        // NYT: lock ny landsdel
        lockedLandsdel = landsdel;
        setPointerMode(landsdel);
        render(landsdel);
      });

      if (!canHover) {
        region.addEventListener(
          "pointerdown",
          e => {
            e.preventDefault();
            e.stopPropagation();

            if (lockedLandsdel === landsdel) {
              resetUI();
              return;
            }

            lockedLandsdel = landsdel;
            setPointerMode(landsdel);
            render(landsdel);
          },
          { passive: false }
        );
      }
    });

    // NYT: klik på baggrunden i svg (ikke på en region) => unlock
    if (svgEl) {
      svgEl.addEventListener("click", e => {
        const clickedOnRegion =
          e.target && e.target.hasAttribute && e.target.hasAttribute("data-landsdel");

        const tag = (e.target && e.target.tagName) ? e.target.tagName.toLowerCase() : "";

        // Klik på svg eller image (baggrund)
        if (!clickedOnRegion && (tag === "svg" || tag === "image")) {
          if (lockedLandsdel) resetUI();
        }
      });
    }

    // NYT: ESC => unlock
    document.addEventListener("keydown", e => {
      if (e.key === "Escape" && lockedLandsdel) resetUI();
    });

    resultsEl.innerHTML =
      "<p class='dk-empty'>Vælg et område for at se camps.</p>";
  }

  function initAll() {
    document.querySelectorAll("[data-dk-map]").forEach(initOne);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", initAll);
  document.addEventListener("shopify:section:select", initAll);
})();